import { mat4, quat, vec2, vec3 } from "gl-matrix";
import Camera from "./Camera";

export default class PerspectiveCamera extends Camera {
  constructor(fov, aspect, near, far) {
    super();

    this.fov = fov; // radian
    this.aspect = aspect;
    this.near = near;
    this.far = far;

    this.updateProjectionMatrix();
  }

  updateProjectionMatrix() {
    mat4.perspective(
      this.projectionMatrix,
      this.fov,
      this.aspect,
      this.near,
      this.far
    );
    return this.projectionMatrix;
  }
}
